/*=============================================== Site data ===============================================*/

import packageJson from "../../package.json"

const versionArr = packageJson.dependencies["tsx-library-julseb"]
    .replace("^", "")
    .split(".")
const version = `${versionArr[0]}.${versionArr[1]}`

export const siteData = {
    name: "Documentation Components library",
    favicon: "/favicon.svg",
    email: "julien.sebag@me.com",
    portfolio: "https://julien-sebag.com/",
    author: "Julien Sebag",
    year: "2023",

    linkCss: 'import "tsx-library-julseb/index.css"',
    linkTypes: (type: string = "") =>
        `import type { ${type} } from "tsx-library-julseb/types"`,
    npmLib: "$ npm i tsx-library-julseb",
    githubRepo: "https://github.com/JulSeb42/tsx-library",
    npmRepo: "https://www.npmjs.com/package/tsx-library-julseb",

    // Meta
    description: "Documentation website for TSX Library julseb",
    cover: "/images/og-cover.jpg",
    type: "library_documentation",
    language: "en_EN",
    keywords: [
        "react-components",
        "tsx-components",
        "styled-components",
        "components",
        "css",
    ],
    version,
}
